import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const FullscreenLoader = ({ open }) => (
    <Backdrop open={open} sx={{ zIndex: theme => theme.zIndex.modal + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
    </Backdrop>
);

export default FullscreenLoader;
